module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_5.8299ce18.jpg";